export default __webpack_public_path__ + "static/media/MIT_LL.02bd545b.png";